import { render, staticRenderFns } from "./DistrictList.vue?vue&type=template&id=7a98ee77"
import script from "./DistrictList.vue?vue&type=script&lang=js"
export * from "./DistrictList.vue?vue&type=script&lang=js"
import style0 from "./DistrictList.vue?vue&type=style&index=0&id=7a98ee77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports